import clsx from "clsx";

const ROWS = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  [",", "0", "back"],
] as const;

export interface NumericKeypadProps {
  value: string;
  onChange: (next: string) => void;
  allowDecimal?: boolean;
  className?: string;
}

export function nextMengeValue(current: string, key: string, allowDecimal: boolean): string {
  if (key === "back") return current.slice(0, -1);
  if (key === ",") {
    if (!allowDecimal || current.includes(",") || current.includes(".")) return current;
    return current ? `${current},` : "0,";
  }
  if (!/^\d$/.test(key)) return current;
  if (current === "0") return key;
  return `${current}${key}`;
}

export function NumericKeypad({
  value,
  onChange,
  allowDecimal = true,
  className,
}: NumericKeypadProps) {
  return (
    <div className={clsx("grid grid-cols-3 gap-2", className)} role="group" aria-label="Zahlentastatur">
      {ROWS.flat().map((key) => {
        const disabled = key === "," && !allowDecimal;
        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            className={clsx(
              "min-h-14 rounded-ios text-xl font-semibold tabular-nums text-label",
              "bg-fill-tertiary ring-1 ring-separator/40",
              "active:bg-fill-secondary disabled:opacity-40",
              key === "back" && "text-base",
            )}
            onClick={() => onChange(nextMengeValue(value, key, allowDecimal))}
          >
            {key === "back" ? "Löschen" : key}
          </button>
        );
      })}
    </div>
  );
}
